(() => {
  const initHarmoniqHeader = (header) => {
    if (!header || header.dataset.hqHeaderInitialized === 'true') return;

    header.dataset.hqHeaderInitialized = 'true';

    let lastScrollY = Math.max(window.scrollY, 0);
    let ticking = false;

    const topThreshold = 4;
    const hideThreshold = 110;
    const directionTolerance = 5;

    const menuToggle = header.querySelector('[data-hq-menu-toggle]');
    const mobileMenu = header.querySelector('[data-hq-mobile-menu]');

    const closeMenu = () => {
      if (!menuToggle || !mobileMenu) return;

      header.classList.remove('is-menu-open');

      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Open menu');

      mobileMenu.setAttribute('aria-hidden', 'true');
    };

    const openMenu = () => {
      if (!menuToggle || !mobileMenu) return;

      header.classList.add('is-menu-open');

      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.setAttribute('aria-label', 'Close menu');

      mobileMenu.setAttribute('aria-hidden', 'false');
    };

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', () => {
        if (header.classList.contains('is-menu-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      mobileMenu
        .querySelectorAll('a')
        .forEach((link) => {
          link.addEventListener('click', closeMenu);
        });

      document.addEventListener('keydown', (event) => {
        if (
          event.key === 'Escape' &&
          header.classList.contains('is-menu-open')
        ) {
          closeMenu();
          menuToggle.focus();
        }
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
          closeMenu();
        }
      });
    }

    const updateHeader = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      const delta = currentScrollY - lastScrollY;

      /*
        At the top:
        normal transparent header over Hero.
      */
      if (currentScrollY <= topThreshold) {
        header.classList.remove(
          'is-floating',
          'is-hidden'
        );
      }

      /*
        Scrolling down.

        Initial header is absolute, so it naturally
        scrolls away with the Hero.

        If floating header is already visible,
        hide it.
      */
      else if (delta > directionTolerance) {
        if (
          header.classList.contains('is-floating') &&
          currentScrollY > hideThreshold
        ) {
          header.classList.add('is-hidden');

          /*
            Never leave the mobile menu open
            behind a hidden header.
          */
          closeMenu();
        }
      }

      /*
        Scrolling upward:
        show floating glass Header.
      */
      else if (delta < -directionTolerance) {
        header.classList.add('is-floating');
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateHeader);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateHeader();
  };

  const initAllHarmoniqHeaders = () => {
    document
      .querySelectorAll('[data-hq-header]')
      .forEach(initHarmoniqHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllHarmoniqHeaders
    );
  } else {
    initAllHarmoniqHeaders();
  }

  /* Shopify Theme Editor */
  document.addEventListener(
    'shopify:section:load',
    initAllHarmoniqHeaders
  );
})();